document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});


 document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.custom-inventory');
    if (!section) return;

    // 1) Random percent between 30 and 70
    const pct = Math.floor(Math.random() * 41) + 30;

    // 2) IntersectionObserver to animate when in view
    const prog = section.querySelector('.progress-inner');
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          prog.style.width = pct + '%';
          obs.unobserve(section);
        }
      });
    }, { threshold: 0.2 });
    io.observe(section);

    // 3) Calculate ship-date = today + 2 days
    const shipEl = section.querySelector('.ship-date-text');
    const d = new Date();
    d.setDate(d.getDate() + 2);
    // e.g. "Mon, May 26"
    const opts = { weekday: 'short', month: 'short', day: 'numeric' };
    shipEl.textContent = d.toLocaleDateString('en-US', opts);
  });

 
